import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const PUT_SERVICE_RESET = 'PUT_SERVICE_RESET';
export const PUT_SERVICE_LOADING = 'PUT_SERVICE_LOADING';
export const PUT_SERVICE_SUCCESS = 'PUT_SERVICE_SUCCESS';
export const PUT_SERVICE_REJECT = 'PUT_SERVICE_REJECT';

//* ACTIONS ------------------------------------------------
export const putServiceReset = () => ({ type: PUT_SERVICE_RESET });
export const putServiceLoading = () => ({ type: PUT_SERVICE_LOADING });
export const putServiceSuccess = (payload) => ({ type: PUT_SERVICE_SUCCESS, payload });
export const putServiceReject = (payload) => ({ type: PUT_SERVICE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const putServiceRequest = async (data, getState, id) => {
    const options = await withToken({
        method: Methods.PUT,
        data,
    }, getState);
    return request(`/Clients/web/UpdateServicesClients`, options);
};


